// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_LEe","cls2":"download_preflight-cls2_ClW download_preflight-cls1_LEe","dp-item-in":"download_preflight-dp-item-in_aXj"};